import { render } from "./followCenter.vue?vue&type=template&id=0ae01bfc&scoped=true"
import script from "./followCenter.vue?vue&type=script&lang=js"
export * from "./followCenter.vue?vue&type=script&lang=js"

import "./followCenter.vue?vue&type=style&index=0&id=0ae01bfc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae01bfc"]])

export default __exports__